import { render } from "./PrepareTab.vue?vue&type=template&id=5990b17a&scoped=true"
import script from "./PrepareTab.vue?vue&type=script&lang=js"
export * from "./PrepareTab.vue?vue&type=script&lang=js"

import "./PrepareTab.vue?vue&type=style&index=0&id=5990b17a&lang=postcss&scoped=true"

import exportComponent from "/codebuild/output/src860361777/src/isi_presenter_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5990b17a"]])

export default __exports__